import axios from "axios";
import { PROVIDERS_REVIEWS, PROVIDERS_REVIEWS_REPLY } from "../../../../config";
import { DataTableHelper } from "../../../../utilities/helpers/DataTableHelper";


export function getProviderReviews(
	sortParam,
	pageSize,
	pageNumber
) {
	return axios.get(
		PROVIDERS_REVIEWS +
			( DataTableHelper.prepareParameters(
				sortParam,
				pageSize,
				pageNumber,
		)),
	);
}

export function getReviewDetails(id) {
	return axios.get(PROVIDERS_REVIEWS + '/' +id);
}

export function replayReview(id,replayTextObj) {
    return axios.post(PROVIDERS_REVIEWS_REPLY + '/' +id, replayTextObj);
}